import { combineEpics } from 'redux-observable';
import { createEventEpic } from './create-event-epic';
import { loadEventEpic } from './load-event-epic';
import { updateEventEpic } from './update-event-epic';

export const eventEpic = combineEpics(
  createEventEpic,
  loadEventEpic,
  updateEventEpic,
);
